import { render, staticRenderFns } from "./MnpRequestList.vue?vue&type=template&id=29825b8d&"
import script from "./MnpRequestList.vue?vue&type=script&lang=js&"
export * from "./MnpRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports